export enum ActionConstants {
	SET_AUTH_REDIRECT = 'SET_AUTH_REDIRECT',
}
